import type { Permission } from "@/types";

/** Build `path` or `path?query`, optionally dropping keys from the current search. */
export function pathWithSearchParams(
  path: string,
  searchParams: URLSearchParams,
  options?: { omit?: readonly string[] },
): string {
  const next = new URLSearchParams(searchParams);
  for (const key of options?.omit ?? []) {
    next.delete(key);
  }
  const query = next.toString();
  return query ? `${path}?${query}` : path;
}

/** First path whose permission the user has; otherwise `fallback`. */
export function firstAllowedPath(
  hasPermission: (permission: Permission) => boolean,
  candidates: readonly { permission: Permission; path: string }[],
  fallback = "/",
): string {
  for (const candidate of candidates) {
    if (hasPermission(candidate.permission)) {
      return candidate.path;
    }
  }
  return fallback;
}
